import { configureStore } from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';
import rootSage from '../Saga/Saga';
import TestReducer from '../Slicers/TestSlicers/TestSlicers';
import UserPermissionRolesReducer from '../Slicers/UserPermission/UserPermissionRolesSlicer';
import UserPermissionRowsReducer from '../Slicers/UserPermission/UserPermissionRowsSlicer';
import DashboardCardReducer from '../Slicers/Dashboard/DashboardCardSlice';
import LoginReducer from "../Slicers/LoginSlicer/LoginSlicer";

import MasterReducer from "../Slicers/Master/MasterSlicer";
import AddMasterReducer from "../Slicers/Master/AddMasterSlicer";
import UpdateMasterReducer from "../Slicers/Master/UpdateMasterSlicer";
import DeleteMasterReducer from "../Slicers/Master/DeleteMasterSlice";
import UnlockMasterReducer from "../Slicers/Master/UnlockMasterSlice";

import SpecialDayReducer from "../Slicers/SpecialDay/SpecialDaySlicer";
import AddSpecialDayReducer from "../Slicers/SpecialDay/AddSpecialDaySlicer";
import UpdateSpecialDayReducer from "../Slicers/SpecialDay/UpdateSpecialDaySlicer";
import DeleteSpecialDayReducer from "../Slicers/SpecialDay/DeleteSpecialDaySlice";

import DesignationReducer from "../Slicers/Designation/DesignationSlicer";
import AddDesignationReducer from "../Slicers/Designation/AddDesignationSlicer";
import UpdateDesignationReducer from "../Slicers/Designation/UpdateDesignationSlicer";
import DeleteDesignationReducer from "../Slicers/Designation/DeleteDesignationSlice";

import SpaceTypesReducer from "../Slicers/SpaceTypes/SpaceTypesSlicer";
import AddSpaceTypesReducer from "../Slicers/SpaceTypes/AddSpaceTypesSlicer";
import UpdateSpaceTypesReducer from "../Slicers/SpaceTypes/UpdateSpaceTypesSlicer";
import DeleteSpaceTypesReducer from "../Slicers/SpaceTypes/DeleteSpaceTypesSlice";

import DayOfWeekReducer from "../Slicers/DayOfWeek/DayOfWeekSlicer";
import AddDayOfWeekReducer from "../Slicers/DayOfWeek/AddDayOfWeekSlicer";
import UpdateDayOfWeekReducer from "../Slicers/DayOfWeek/UpdateDayOfWeekSlicer";
import DeleteDayOfWeekReducer from "../Slicers/DayOfWeek/DeleteDayOfWeekSlice";

import ForgetPasswordReducer from "../Slicers/ForgetPassword/ForgetPasswordSlicer";
import ForgetPasswordMailReducer from "../Slicers/ForgetPassword/ForgetPasswordMailSlice";
import OwnerReducer from "../Slicers/Owner/OwnerSlicer";
import AddOwnerReducer from "../Slicers/Owner/AddOwnerSlicer";
import UpdateOwnerReducer from "../Slicers/Owner/UpdateOwnerSlicer";
import DeleteOwnerReducer from "../Slicers/Owner/DeleteOwnerSlice";

import PackagemanagementCardReducer from "../Slicers/PackageManagement/PackageManagementCardSlice";
import AddPackageReducer from "../Slicers/PackageManagement/AddPackageManagementSlicer";
import UpdatePackageReducer from "../Slicers/PackageManagement/UpdatePackageManagementSlicer";
import DeletePackageReducer from "../Slicers/PackageManagement/DeletePackageManagementSlice";

import VehicleReducer from "../Slicers/Vehicle/VehicleSlicer";
import AddVehicleReducer from "../Slicers/Vehicle/AddVehicleSlicer";
import UpdateVehicleReducer from "../Slicers/Vehicle/UpdateVehicleSlicer";
import DeleteVehicleReducer from "../Slicers/Vehicle/DeleteVehicleSlice";

import MembershipVehicleReducer from "../Slicers/MembershipVehicle/MembershipVehicleSlicer";
import AddMembershipVehicleReducer from "../Slicers/MembershipVehicle/AddMembershipVehicleSlicer";
import UpdateMembershipVehicleReducer from "../Slicers/MembershipVehicle/UpdateMembershipVehicleSlicer";
import DeleteMembershipVehicleReducer from "../Slicers/MembershipVehicle/DeleteMembershipVehicleSlice";

import LocationReducer from "../Slicers/Location/LocationSlicer";
import AddLocationReducer from "../Slicers/Location/AddLocationSlicer";
import UpdateLocationReducer from "../Slicers/Location/UpdateLocationSlicer";
import DeleteLocationReducer from "../Slicers/Location/DeleteLocationSlice";
import GetOneLocationReducer from "../Slicers/Location/GetOneLocationSlicer copy";
import GetAdsReducer from "../Slicers/Location/GetAdsSlicer";

import TariffReducer from "../Slicers/Tariff/TariffSlicer";
import AddTariffReducer from "../Slicers/Tariff/AddTariffSlicer";
import UpdateTariffReducer from "../Slicers/Tariff/UpdateTariffSlicer";
import DeleteTariffReducer from "../Slicers/Tariff/DeleteTariffSlice";

import SlotReducer from "../Slicers/Slot/SlotSlicer";
import AddSlotReducer from "../Slicers/Slot/AddSlotSlicer";
import UpdateSlotReducer from "../Slicers/Slot/UpdateSlotSlicer";
import DeleteSlotReducer from "../Slicers/Slot/DeleteSlotSlice";
import UpdateSlotOrderReducer from "../Slicers/Slot/UpdateSlotOrderSlicer";
import FixtureReducer from "../Slicers/Fixtures/FixtureSlicer";
import AddFixtureReducer from "../Slicers/Fixtures/AddFixtureSlicer";
import UpdateFixtureReducer from "../Slicers/Fixtures/UpdateFixtureSlicer";
import UpdateFixtureOrderReducer from "../Slicers/Fixtures/UpdateFixtureOrderSlicer";
import DeleteFixtureReducer from "../Slicers/Fixtures/DeleteFixtureSlice";
import SpaceReducer from "../Slicers/Space/SpaceSlicer";
import AddSpaceReducer from "../Slicers/Space/AddSpaceSlicer";
import UpdateSpaceReducer from "../Slicers/Space/UpdateSpaceSlicer";
import UpdateSpaceOrderReducer from "../Slicers/Space/UpdateSpaceOrderSlicer";
import DeleteSpaceReducer from "../Slicers/Space/DeleteSpaceSlice";

import PricingSlicer from "../Slicers/Pricing/PricingSlicer";
import AddPricingSlicer from "../Slicers/Pricing/AddPricingSlicer";
import UpdatePricingSlicer from "../Slicers/Pricing/UpdatePricingSlicer";
import DeletePricingSlice from "../Slicers/Pricing/DeletePricingSlice";

import SalesReducer from "../Slicers/Sales/SalesSlicer";
import SubscriptionReducer from "../Slicers/Sales/SubscriptionSlicer";

import InvalidTokenReducer from "../Slicers/InvalidToken/InvalidTokenSlice";

import ParkingTypeReducer from "../Slicers/ParkingType/ParkTypeSlicer";
import UsersReducer from "../Slicers/Users/UsersSlicer";
import UsersCreateReducer from "../Slicers/Users/UsersCreateSlicer";
import UsersUpdateReducer from "../Slicers/Users/UsersUpdateSlicer";
import UsersDeleteReducer from "../Slicers/Users/UsersDeleteSlice";
import DisplayDeviceReducer from "../Slicers/DisplayDevice/DisplayDeviceSlicer";
import AddDisplayDeviceReducer from "../Slicers/DisplayDevice/AddDisplayDeviceSlicer";
import UpdateDisplayDeviceReducer from "../Slicers/DisplayDevice/UpdateDisplayDeviceSlicer";
import DeleteDisplayDeviceReducer from "../Slicers/DisplayDevice/DeleteDisplayDeviceSlice";

const sagaMiddleware = createSagaMiddleware();

export const store = configureStore({
  reducer: {
    Test: TestReducer,
    // Dashboard
    DashboardCard: DashboardCardReducer,

    PackageManagementCard: PackagemanagementCardReducer,
    AddPackage: AddPackageReducer,
    UpdatePackage: UpdatePackageReducer,
    DeletePackage: DeletePackageReducer,

    // User Permission
    UserPermissionRoles: UserPermissionRolesReducer,
    UserPermissionRows: UserPermissionRowsReducer,
    // Login
    LoginSlicer: LoginReducer,

    // Master
    Master: MasterReducer,
    AddMaster: AddMasterReducer,
    UpdateMaster: UpdateMasterReducer,
    DeleteMaster: DeleteMasterReducer,
    UnlockMaster: UnlockMasterReducer,

    // SpecialDay
    SpecialDay: SpecialDayReducer,
    AddSpecialDay: AddSpecialDayReducer,
    UpdateSpecialDay: UpdateSpecialDayReducer,
    DeleteSpecialDay: DeleteSpecialDayReducer,

    // Designation
    Designation: DesignationReducer,
    AddDesignation: AddDesignationReducer,
    UpdateDesignation: UpdateDesignationReducer,
    DeleteDesignation: DeleteDesignationReducer,

    // SpaceTypes
    SpaceTypes: SpaceTypesReducer,
    AddSpaceTypes: AddSpaceTypesReducer,
    UpdateSpaceTypes: UpdateSpaceTypesReducer,
    DeleteSpaceTypes: DeleteSpaceTypesReducer,

    // DayOfWeek
    DayOfWeek: DayOfWeekReducer,
    AddDayOfWeek: AddDayOfWeekReducer,
    UpdateDayOfWeek: UpdateDayOfWeekReducer,
    DeleteDayOfWeek: DeleteDayOfWeekReducer,

    // ForgetPassword
    ForgetPassword: ForgetPasswordReducer,
    ForgetPasswordMail: ForgetPasswordMailReducer,
    //owner
    Owner: OwnerReducer,
    AddOwner: AddOwnerReducer,
    UpdateOwner: UpdateOwnerReducer,
    DeleteOwner: DeleteOwnerReducer,

    //Vehicle
    Vehicle: VehicleReducer,
    AddVehicle: AddVehicleReducer,
    UpdateVehicle: UpdateVehicleReducer,
    DeleteVehicle: DeleteVehicleReducer,

    //MembershipVehicle
    MembershipVehicle: MembershipVehicleReducer,
    AddMembershipVehicle: AddMembershipVehicleReducer,
    UpdateMembershipVehicle: UpdateMembershipVehicleReducer,
    DeleteMembershipVehicle: DeleteMembershipVehicleReducer,

    //Location
    Location: LocationReducer,
    AddLocation: AddLocationReducer,
    UpdateLocation: UpdateLocationReducer,
    DeleteLocation: DeleteLocationReducer,
    GetOneLocation: GetOneLocationReducer,
    GetAds: GetAdsReducer,

    // Tariff
    Tariff: TariffReducer,
    AddTariff: AddTariffReducer,
    UpdateTariff: UpdateTariffReducer,
    DeleteTariff: DeleteTariffReducer,

    // Slot
    Slot: SlotReducer,
    AddSlot: AddSlotReducer,
    UpdateSlot: UpdateSlotReducer,
    UpdateSlotOrder: UpdateSlotOrderReducer,
    DeleteSlot: DeleteSlotReducer,

    // Fixture
    Fixture: FixtureReducer,
    AddFixture: AddFixtureReducer,
    UpdateFixture: UpdateFixtureReducer,
    DeleteFixture: DeleteFixtureReducer,
    UpdateFixtureOrder: UpdateFixtureOrderReducer,

    // Space
    Space: SpaceReducer,
    AddSpace: AddSpaceReducer,
    UpdateSpace: UpdateSpaceReducer,
    UpdateSpaceOrder: UpdateSpaceOrderReducer,

    DeleteSpace: DeleteSpaceReducer,
    // Pricing
    Pricing: PricingSlicer,
    AddPricing: AddPricingSlicer,
    UpdatePricing: UpdatePricingSlicer,
    DeletePricing: DeletePricingSlice,

    //sales
    Sales: SalesReducer,
    Subscription: SubscriptionReducer,

    //parkingtype
    ParkingType: ParkingTypeReducer,
    // InvalidToken
    InvalidToken: InvalidTokenReducer,
    // Users
    Users: UsersReducer,
    UsersCreate: UsersCreateReducer,
    UsersUpdate: UsersUpdateReducer,
    UsersDelete: UsersDeleteReducer,
    // DisplayDevice
    DisplayDevice: DisplayDeviceReducer,
    AddDisplayDevice: AddDisplayDeviceReducer,
    UpdateDisplayDevice: UpdateDisplayDeviceReducer,
    DeleteDisplayDevice: DeleteDisplayDeviceReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(sagaMiddleware),
});

sagaMiddleware.run(rootSage);

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;

